import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  IconButton,
  Paper,
  useTheme,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
import CurrencyYenIcon from "@mui/icons-material/CurrencyYen";
import { useTranslation } from "react-i18next";
import nccBuildingImg from "images/GroupCompany/ncc-building.jpeg";
import BgTitle from "components/title/BgTitle";

export default () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const statistics = [
    {
      key: t("home_section6_founding_key"),
      value: t("home_section6_founding_value"),
      icon: <BusinessIcon />,
    },
    {
      key: t("home_section6_main_office_key"),
      value: t("home_section6_main_office_value"),
      icon: <HomeIcon />,
    },
    {
      key: t("home_section6_employee_key"),
      value: t("home_section6_employee_value"),
      icon: <GroupIcon />,
    },
    {
      key: t("home_section6_capital_key"),
      value: t("home_section6_capital_value"),
      icon: <CurrencyYenIcon />,
    },
  ];

  return (
    <Box
      sx={{
        position: "relative",
        py: 3,
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${nccBuildingImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.3,
          zIndex: -1,
        },
      }}
    >
      <Container maxWidth="lg">
        {/* Header Section */}
        <Box sx={{ mb: 4, px: 1 }}>
          <BgTitle text={t("home_section6_title")} isCenter={true} />
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              textAlign: "center",
              fontSize: "0.7rem",
              lineHeight: 1.6,
              fontWeight: 500,
              mt: 1,
            }}
          >
            {t("home_section6_desc")}
          </Typography>
        </Box>

        {/* Statistics Grid */}
        <Grid container spacing={2}>
          {statistics.map((stat, index) => (
            <Grid item xs={6} key={index}>
              <Paper
                elevation={0}
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  overflow: "hidden",
                  border: `1px solid ${theme.palette.divider}`,
                }}
              >
                {/* Card Header */}
                <Box
                  sx={{
                    p: 1,
                    bgcolor: "#f5f5f5",
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    borderBottomLeftRadius: 12,
                    borderBottomRightRadius: 12,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <IconButton
                    size="small"
                    sx={{
                      color: "#1976d2",
                      bgcolor: "primary.lighter",
                    }}
                  >
                    {stat.icon}
                  </IconButton>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "black",
                      fontWeight: 650,
                      fontSize: "0.8rem",
                    }}
                  >
                    {stat.key}
                  </Typography>
                </Box>

                {/* Card Content */}
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 500,
                      fontSize: "0.7rem",
                      color: "text.primary",
                    }}
                  >
                    {stat.value}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
